// api.js
export default async function login(username, password) {
  try {
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", password);

    // Call the PHP login API
    let response = await fetch(
      "https://iglesiaevangelicadelafe.com/api-church/login.php",
      {
        method: "POST",
        body: formData,
      }
    );

    // Check if response is ok
    if (!response.ok) {
      console.error("HTTP error:", response.status, response.statusText);
      return { success: false, message: `HTTP error: ${response.status}` };
    }

    // Get the response text first to check if it's valid JSON
    const responseText = await response.text();

    // 🔍 Debug: show what the backend returned
    console.log("Login API raw response:", responseText);

    let data;
    try {
      // Try to parse as JSON
      data = JSON.parse(responseText);
    } catch (jsonError) {
      console.error("Invalid JSON response:", responseText);
      return {
        success: false,
        message: "Server returned invalid JSON response",
      };
    }

    // 🔍 Debug: show the parsed JSON
    console.log("Login API parsed response:", data);

    // Return the parsed JSON to the caller
    return data;
  } catch (error) {
    console.error("Error during login:", error);
    return { success: false, message: "Network error during login" };
  }
}
